<template>
    <div>
        <!--   <h1>{{ name }}</h1> {{ filters }}
           {{ fields }} -->


        <v-alert class="mt-4" color="light-blue" outlined dense icon="mdi-school" text type="info" v-if="helpText">
            {{ helpText }} </v-alert>

        <v-row>
            <v-col cols="12" sm="12" md="9" order-sm="2" order-md="1" v-if="!hideTable">
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-icon large>{{ icon }}</v-icon>
                        <v-toolbar-title class="ma-5">{{ name }}</v-toolbar-title>
                        <div class="flex-grow-1"></div>

                        <v-col cols="3">
                            <v-text-field v-model="searchString" append-icon="mdi-magnify" v-show="data.length >0"
                                :label="t('common', 'STR_SEARCH')" single-line hide-details></v-text-field>
                        </v-col>
                       
                                                    <aed-export-icons 
  :exports-data="exportsFormats" 
  :base-url="webservice"
  :search-string="searchString"
  :filters="filters"
  color="white"
/>
                        

                     


                    </v-toolbar>

                    <v-card-text>
                        <v-data-table :headers="headers" :items="data" :items-per-page="15" class="elevation-1"
                            :search="searchString">


                            <template v-slot:item="{ item }">
                                <tr :class="getRowClass">
                                    <td v-for="(value, key) in item" :key="key" v-if="key !== '__attr'">
                                        <a v-if="key === linkedField"
                                            :href="linkedRoute + '?' + linkedField.toLowerCase() + '=' + value"
                                            target="_blank">
                                            {{ value }}
                                        </a>
                                        <span v-else>
                                            {{ value }}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="item.__attr" class="ml-2">

                                            <v-tooltip bottom>

                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon small color="primary" v-bind="attrs" v-on="on">
                                                        mdi-information-slab-circle
                                                    </v-icon>
                                                </template>

                                                <span>{{ item.__attr.title }}</span>

                                            </v-tooltip>

                                        </span>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>


                 
                            <aed-table-legend :service="this.webservice" orientation="horizontal" />
                  
                    </v-card-text>

                </v-card>


            </v-col>

            <v-col cols="12" sm="12" :md="hideTable ? 9 : 3" :order-sm="hideTable ? 1 : 1"
                :order-md="hideTable ? 1 : 2">
                <v-card>
                    <v-toolbar color="primary" dark flat>
                        <v-icon large>mdi-magnify</v-icon>
                        <v-toolbar-title class="ma-5">{{ t("common", "STR_SEARCH") }}</v-toolbar-title>
                        <div class="flex-grow-1"></div>
                    </v-toolbar>
                    <v-form ref="genericSearchForm" @submit.prevent="submitForm" lazy-validation>
                        <v-card-text v-if="fields.length !== 0">


                            <template v-for="(field, key) in fields">



                                <aed-contact-selector v-if="field.ESEL === true" v-model="filters[key]"
                                    :field="field"></aed-contact-selector>

                                <aed-text-field v-else-if="field.TYPE === 'W'" v-model="filters[key]" :field="field"
                                    :key="key"></aed-text-field>
                                <aed-text-field v-else-if="field.TYPE === 'H'" v-model="filters[key]" :field="field"
                                    v-show="false"></aed-text-field>
                                <aed-text-field v-else-if="field.TYPE === 'N'" v-model="filters[key]"
                                    :field="field"></aed-text-field>

                                <aed-date-picker-auto v-else-if="field.TYPE === 'D'" v-model="filters[key]"
                                    :field="field"></aed-date-picker-auto>


                                <aed-date-range v-else-if="field.TYPE === 'D2'" :from.sync="filters[key + '_von']"
                                    :to.sync="filters[key + '_bis']"
                                    :labels="{ from: getLabel(field) + ' von', to: 'bis' }" :field="field" />


                                <aed-select v-else-if="field.TYPE === 'O'" v-model="filters[key]"
                                    :field="field"></aed-select>


                                <v-checkbox v-else-if="field.TYPE === 'C'" v-model="filters[key]"
                                    :label="field.NAME"></v-checkbox>
                            </template>






                        </v-card-text>

                        <v-card-actions>

                            <v-btn large color="primary" class="ma-2 text--right" @click="submitForm">
                                <v-icon>mdi-magnify</v-icon>
                                {{ this.t("common", "STR_SEARCH") }}
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>

            </v-col>

        </v-row>




    </div>




</template>
<!-- <style>
.CL-C50000{
    background-color: aqua;
}
</style> -->

<script>
import field from '../mixins/field.js'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'aedGenericSearch',
    mixins: [field],
    props: {
        /**
         * The name of the table component.
         * @type {string}
         */
        name: String,

        /**
         * The webservice endpoint used to fetch data for the table.
         * @type {string}
         */
        webservice: String,

        /**
         * The icon to be displayed next to the table name.
         * @type {string}
         */
        icon: String,

        /**
         * Help text that provides additional information about the table.
         * @type {string}
         */
        helpText: String,

        /**
         * Flag indicating whether data should be loaded on component initialization.
         * @type {boolean}
         */
        loadDataOnInit: Boolean,

        /**
         * Flag indicating whether table should be loaded on component initialization.
         * @type {boolean}
         */
        hideTable: Boolean,

        /**
         * The route linked to the table, used for navigation.
         * @type {string}
         */
        linkedRoute: String,

        /**
         * The field in the table that is used as a link for navigation.
         * @type {string}
         */
        linkedField: String,

        /**
         * Object containing additional field values for filtering or customization.
         * @type {Object}
         */
        fieldValues: Object,
    },
    data() {
        return {

            headers: [],
            data: [],
            fields: {},
            filters: {},
            searchString: '',
            exportsFormats:[],

            noTable: false

        };
    },

    /**
           * Loads the initial data, filter fields, and table headers.
           * Optionally fetches default filter values and initial data.
           */
    created() {
        this.getFields();
        this.getHeaders();
        if (this.loadDataOnInit) {
            this.queryData();
        }
        if (this.fieldValues) {
            this.filters = this.fieldValues
            this.queryData();

        }
    },
    methods: {
        getRowClass(item) {
            console.log(item)

            if (item.__attr && item.__attr.CssClass) {
                // Return the style string, ensuring '!important' is used to override Vuetify's default coloring.
                // Note: The color string itself must be defined, like '#FFFFE0' or 'yellow'.
                return item.__attr.CssClass;
            }
        },
        // get Fields for Search Form from Backend DAMAGES API and with opcode=JI
        async getFields() {

            try {
                const response = await axios.get(this.webservice, {
                    params: {
                        opcode: 'JI',
                        format: 'J',
                    },
                });
                if (response.data) {
                    this.fields = response.data;
                }
            } catch (error) {
                console.error('Failed to fetch fields:', error);
            }

        },

        /**
        * Fetches the table headers from the backend service.
        */
        async getHeaders() {
            if (this.hideTable) return
            try {
                const response = await axios.get(this.webservice, {
                    params: {
                        opcode: 'JO',
                        format: 'J', 
                        opcver:2,
                    },
                });
                //this.headers = Object.keys(response.data).filter((key) => response.data[key].OPTIONAL !== true).map((key) => {

                this.headers = Object.keys(response.data.HEADERS).map((key) => {
                    return {
                        text: response.data.HEADERS[key].NAME,
                        value: key,
                        align: 'left',
                    };
                });

                // if header have __attr field, set align to 'd-none' to hide column
                this.headers.push({ text: '__attr', value: '__attr', align: ' d-none' });
                this.exportsFormats = response.data.PARAMS.EXPORTS
                /* this.headers.forEach((item) => {
                    if (item.value === '__attr') {
                        item.align = 'hidden-column';
                    }
                }); */


            } catch (error) {
                console.error('Failed to fetch headers:', error);
            }
        },

        

        /**
         * Validates and submits the filter form.
         */
        submitForm() {
            if (this.$refs.genericSearchForm === undefined) {
                this.queryData();
            } else {
                if (this.$refs.genericSearchForm.validate()) {
                    this.queryData();
                }
            }


        },
        /**
       * Fetches data from the backend service and prepares it for table display.
       */
        queryData() {
            const t = this;
            let tmpFilters = {};

            // Nur Filter mit Werten senden
            for (const key in this.filters) {
                if (this.filters[key] !== '') {
                    tmpFilters[key] = this.filters[key];
                }
            }

            // Format-Bestimmung
            const targetFormat = tmpFilters.format || this.format || 'J';

            // FALL 1: Download (Nicht JSON)
            if (targetFormat !== 'J') {
                // 1. Parameter zusammenbauen
                const params = new URLSearchParams({
                    opcode: 'L',
                    ...tmpFilters,
                    format: targetFormat
                }).toString();

                // 2. Komplette URL generieren
                const downloadUrl = `${this.webservice}?${params}`;

                // 3. In neuem Tab öffnen
                // '_blank' sorgt für den neuen Tab
                window.open(downloadUrl, '_blank');

                // 4. Axios-Teil überspringen
                return;
            }

            // FALL 2: JSON Daten (Axios)
            t.$store.commit('setLoadingState', true);

            const axiosConfig = {
                params: {
                    opcode: 'L',
                    ...tmpFilters,
                    format: 'J'
                },
                headers: {
                    'Accept': 'application/json'
                }
            };

            axios.get(this.webservice, axiosConfig)
                .then((response) => {
                    if (response.data.length === 0) {
                        t.$store.dispatch('showMessage', {
                            type: 'Info',
                            text: t.t('common', 'STR_NOENTRIESFOUND')
                        });
                    }
                    t.data = response.data;
                })
                .catch((error) => {
                    console.error('Failed to fetch data:', error);
                })
                .finally(() => {
                    t.$store.commit('setLoadingState', false);
                });
        },
    }

};
</script>
<style scoped>
.hidden-column {
    display: none;
}
</style>